'use strict';
import {getId} from '../../../core-utilities/domain/ReduxUtils';


module.exports = [
  '$modal',
  '$scope',
  '$miscUtils',
  'OrganizationInviteDomain',
  '$toast',
  'person',
  'invite',
  'organization',
  'DEFAULT_ROLES',
  InvitesCreateController];

// TODO: Add support for custom assigning custom roles
function InvitesCreateController(
  $modal,
  $scope,
  $miscUtils,
  OrganizationInviteDomain,
  $toast,
  existingAlias,
  existingInvite,
  organization,
  DEFAULT_ROLES,
) {
  const vm = $scope.invitesCreate = initViewModel(this, existingInvite);
  vm.editing = !!existingInvite;
  vm.roles = DEFAULT_ROLES.toLinksList();

  vm.save = $miscUtils.blockPromise(existingInvite ? save : send);
  vm.cancel = !existingInvite
    ? $modal.cancel.bind($modal)
    : function revertDataAndClose() {
      vm.model.$revert();
      $modal.cancel();
    };


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  // TODO: move to server to support email updates
  function save() {
    // if only role is changed, just update the server

    // if the email changed, we need to delete the old invitation and create a new one

    // if the name changed, we might want to send a new email
    return vm.model.$save()
      .then(_onSuccess, _onError);
  }

  function send() {
    if (!OrganizationInviteDomain.validateInvite(vm.model)) {
      console.warn('Failed to validate invite', vm.model.$errors);
      return Promise.reject(vm.model.$errors);
    } else {
      return OrganizationInviteDomain.send(vm.model)
        .then(function () {
          $toast.showI18nMessage({
            messageId: 'invites.create.success.message',
            messageParams: {recipient: vm.model.toString()},
            type: 'info',
          });
          _onSuccess();
        }, _onError);
    }
  }

  function _onSuccess() {
    $modal.hide();
  }

  // TODO: show errors in view
  function _onError(error) {
    console.error(error);
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/


  /*****************************************************************************************************************
   * Load Data
   ****************************************************************************************************************/


  function initViewModel(vm, invite) {
    if (invite) {
      vm.createMode = false;
      vm.model = invite;
    } else {
      vm.createMode = true;
      vm.model = OrganizationInviteDomain.createInvite(existingAlias);
      vm.model.organization = getId(organization);
    }

    return vm;
  }
}



// WEBPACK FOOTER //
// ./src/js/personnel/controllers/admin/InvitesCreateController.js